controllers.controller('VerificationV2Controller', [
    '$scope', '$state', '$ionicLoading', '$ionicPopup', 'LocaleService', 'constants',
    'API', 'ErrorService', 'VerificationV2Service', 'UserControl', 'UserService',
    function ($scope, $state, $ionicLoading, $ionicPopup, LocaleService, Const,
              API, ErrorService, VerificationV2Service, UserControl, UserService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.constants = Const;

        $scope.documents = [];

        $scope.isApproved = false;

        $scope.myPopup = null;

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            actionText: LocaleService.translation.try_again,
            back: ''
        };

        $scope.modal = angular.copy(modalDefaults);


        VerificationV2Service.init()
            .then(function () {
                $scope.documents = VerificationV2Service.collection.getAll();

                if ($scope.documents.length === 0) {
                    $scope.isApproved = true;
                }

            })

        $scope.uploadFile = function (event) {
            var file = event.target.files[0];
            var id = event.target.attributes['file-id'].value;
            var side = Number(event.target.attributes['file-side'].value);
            var document = _.find($scope.documents, {id: id.toString()});

            if (!file || !document) {
                console.warn('file is not selected or document is not found');
                return;
            }
            document.uploadStatus = 0;
            if (!checkFileType(file.type)) {
                document.uploadStatus = -1;
                message = LocaleService.translation.file_incorrect_type;
                //console.log('invalid file type');
            } else if (!checkFileSize(file.size)) {
                document.uploadStatus = -2;
                message = LocaleService.translation.file_is_big_or_small;
                //console.log('file too big or small');
            }

            if (document.uploadStatus < 0) {
                $scope.modal.textTitle = LocaleService.translation.messages.Err600;
                $scope.modal.textContent = message;
                $scope.modal.isError = true;
                $scope.modal.state = true;
                return;
            } //exit if file is not validated

            $ionicLoading.show();

            return document.startUpload(file, side)
                .then(function (newFileName) {
                    return document.uploadFile(file, newFileName)
                })
                .then(function () {
                    document.uploaded[side] = true;
                    document.updateStatus();
                    document.hasUploaded = true;
                    document.uploadStatus = 0;
                    //VerificationV2Service.updateState()
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.successful;
                    $scope.modal.textContent = '';
                    $scope.modal.actionText = LocaleService.translation.ok;
                    $scope.modal.isError = false;
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    document.status = 'new';
                    document.uploadStatus = 0;
                    console.warn(error);
                    $scope.modal.textTitle = error && error.code && LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.textContent = error && error.code && error.code.toString().match(/^Err6\d\d$/) ? LocaleService.translation.messages.general_error_text : '';
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.state = true;
                })
        }


        $scope.toggleImage = function (document) {
            document.toggleImage();
            document.twoSidedToggled = !document.twoSidedToggled;
        }

        $scope.showSubtype = function (document) {
            $scope.selectedDocument = document;
            $scope.myPopup = $ionicPopup.show({
                templateUrl: 'templates/verification-v2-subtypes.html',
                title: $scope.translation['selectOption'],
                scope: $scope,
                buttons: [
                    {
                        text: $scope.translation['select'],
                        type: 'button-full',
                        onTap: function (e) {
                            e.preventDefault();
                            $scope.document = $scope.selectedDocument;
                            $scope.myPopup.close();
                        }
                    }
                ]
            });
        };

        function checkFileType(type) {
            return Const.fileTypes.filter(function (_type) {
                return _type === type;
            }).length > 0;
        }

        function checkFileSize(size) {
            return size >= Const.minFileSize && size <= Const.maxFileSize;
        }

        $scope.$on('$ionicView.beforeLeave', function () {
            $scope.myPopup && $scope.myPopup.close();
            $scope.myPopup = null;
        });

        $scope.$on('$ionicView.beforeEnter', function () {
            var user = UserService.get();
            $scope.state = UserControl.getState();

            if (user && user.liveAccountExists) {
                return
            }

            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }
            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
            }
        });
    }
])
